module.exports = __webpack_public_path__ + "static/media/38.253efd52.JPG";